module.exports = __webpack_public_path__ + "img/bards.711155bf.jpg";